export default __webpack_public_path__ + "static/media/prospectIcon.689c2419.svg";